import { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

class GroupItemActions extends Component {
	/*

	constructor(props) {

		super();

		this.state = {

			post: props.post,
			feed: props.feed[post.id.split('-').slice(0, 2).join('-')],

		};

	}

	changeGroupAdmin = (t) => {

		let post = this.props.post;

		let state = this.state;

		let obj = post.id.split('-').slice(0, 2).join('-');

		this.props.complete();

		http[t?'delete':'post']('/data/groups/'+obj+'/admin', {uid: post.u}).then(data => {

			let f = {feed: {}};

			f.feed[obj] = {

				admins: data.admins,

			};

			this.props.dispatch({
				type: 'STORE_FEED',
				data: f,
			});

		});

	}

*/

	render() {
		return null;

		/*
		let state = this.state;

		let creator = state.feed.creator;

		let post = this.props.post;

		let out = [];

		let isAdmin = !!state.admins.indexOf(post.u);

		if (creator == props.user.id) {

			out.concat([

				<DropdownItem key={'m-group_admin1'} header>
					Group Admin
				</DropdownItem>,

				<DropdownItem key={'m-group_admin2'} onClick={() => {this.changeGroupAdmin(isAdmin)}}>
					{isAdmin?'Remove As Admin':'Make Group Admin'}
				</DropdownItem>,

			]);

		}

		return out;

*/
	}
}

export default ReduxConnect(GroupItemActions, {
	feed: 'feed',
	user: 'user',
});
